export const INITIAL_RCC_INDICATORS = [
  {
    id: "rcc-1",
    code: "RCC-001",
    name: "Number of projects completed",
    description: "Tracks completed projects submitted by district teams.",
    status: "Active",
    subGroups: [
      {
        id: "rcc-1-group-1",
        name: "Completion Verification",
        owner: "RCC Monitoring Team",
        status: "Active",
        subIndicators: [
          { id: "rcc-1-sub-1", name: "Projects verified on site", threshold: "100%", source: "Field validation" },
          { id: "rcc-1-sub-2", name: "Completion certificates uploaded", threshold: ">= 90%", source: "Project registry" },
        ],
      },
      {
        id: "rcc-1-group-2",
        name: "District Submission Quality",
        owner: "Regional Super User",
        status: "Inactive",
        subIndicators: [
          { id: "rcc-1-sub-3", name: "Supporting evidence attached", threshold: "All submissions", source: "Submission audit" },
        ],
      },
    ],
  },
  {
    id: "rcc-2",
    code: "RCC-002",
    name: "No. of rollover projects",
    description: "Captures projects carried over into the next reporting period.",
    status: "Inactive",
    subGroups: [
      {
        id: "rcc-2-group-1",
        name: "Rollover Classification",
        owner: "Projects Desk",
        status: "Active",
        subIndicators: [
          { id: "rcc-2-sub-1", name: "Projects beyond approved timeline", threshold: "<= 10%", source: "Implementation tracker" },
          { id: "rcc-2-sub-2", name: "Projects re-budgeted for next cycle", threshold: "Tracked quarterly", source: "Budget review" },
        ],
      },
    ],
  },
  {
    id: "rcc-3",
    code: "RCC-003",
    name: "Budget absorption rate",
    description: "Measures how much of the approved allocation has been utilized.",
    status: "Active",
    subGroups: [
      {
        id: "rcc-3-group-1",
        name: "Quarterly Spend Monitoring",
        owner: "Finance Team",
        status: "Active",
        subIndicators: [
          { id: "rcc-3-sub-1", name: "Quarterly allocation released", threshold: "100%", source: "Finance ledger" },
          { id: "rcc-3-sub-2", name: "Quarterly spend vs release", threshold: ">= 85%", source: "Expenditure return" },
        ],
      },
    ],
  },
];
